module.exports = __webpack_public_path__ + "media/images/flags/64/San-Marino-77eef64b50f54b503d93ff63f52ed95e.png";